import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { FiGrid, FiArrowRight, FiUserCheck, FiLogOut } from 'react-icons/fi';

const Navbar = () => {
  const { user, business, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <nav className="landing-navbar">
      <div className="container navbar-inner">
        <Link to="/" className="brand-logo">
          {/* <div className="brand-badge">
            <FiGrid />
          </div>
          <span>Digital Business Kit</span> */}
          <img src='/assets/dashlogo.png' alt='' />
        </Link>

        <ul className="nav-links">
          <li><a href="#features" className="nav-link">Features</a></li>
          <li><a href="#how-it-works" className="nav-link">How It Works</a></li>
          <li><a href="#pricing" className="nav-link">Pricing</a></li>
          <li><a href="#faq" className="nav-link">FAQ</a></li>
        </ul>

        <div className="nav-actions">
          {user ? (
            <>
              {user.role === 'admin' && (
                <Link to="/admin" className="btn btn-secondary btn-sm">
                  Admin Panel
                </Link>
              )}

              {business ? (
                <Link to="/dashboard" className="btn btn-primary btn-sm">
                  <FiUserCheck /> Dashboard
                </Link>
              ) : (
                <Link to="/setup-business" className="btn btn-primary btn-sm">
                  Setup Business <FiArrowRight />
                </Link>
              )}

              <button onClick={() => { logout(); navigate('/'); }} className="btn btn-secondary btn-sm" title="Logout">
                <FiLogOut />
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="btn btn-secondary btn-sm">
                Login
              </Link>
              <Link to="/register" className="btn btn-primary btn-sm">
                Get Started <FiArrowRight />
              </Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
